import {GET_REPORTING,GET_REPORTING_DATA,GET_REPORTING_START,GET_REPORTING_END}
from './type'
import { validateToken, redirectToLogin } from '../../utils/auth/tokenValidation';

interface Action {
  type: string;
  payload?: any; 
  loading?: boolean;
}

type Dispatch = (action: Action) => any;

const API_URL = process.env.REACT_APP_API_URL


export const SearchFilter = (payload: any): any => async (dispatch: Dispatch): Promise<any> =>{

  if (!validateToken()) {
    redirectToLogin();
    return { success: false, message: "Authentication required" };
  }

  try {
      dispatch({ type: GET_REPORTING_START, loading: true });

      const token = localStorage.getItem("loginToken");
      if (!token) {
        throw new Error("Authorization token not found");
    }
      const response = await fetch(`${API_URL}/campaign/getCampaignAuditReport`, {
          method: "POST",
          headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify(payload) 
      });
      const res = await response.json();
      if (res.loginToken) {

          dispatch({ type: GET_REPORTING_DATA, payload: res, loading: false });
          return { success: true, ...res }; 
      } else {
          dispatch({ type: GET_REPORTING_END, payload: res.message, loading: false });
          return { success: false, ...res }; 
      }
  } catch (error: any) {
      dispatch({ type: GET_REPORTING_END, payload: error.message, loading: false });
      return { success: false, message: error.message };
  }
};





export const ExportFile = (payload: any): any => async (dispatch: Dispatch): Promise<any> =>{
  
  if (!validateToken()) {
    redirectToLogin();
    return { success: false, message: "Authentication required" };
  }
  
  try {
      dispatch({ type: GET_REPORTING_START, loading: true });

      const token = localStorage.getItem("loginToken");
      if (!token) {
        throw new Error("Authorization token not found");
    }
      const response = await fetch(`${API_URL}/campaign/exportCampaignAuditReport`, {
          method: "POST",
          headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify(payload) 
      });
      const res = await response.json();
      if (res.loginToken) {

          dispatch({ type: GET_REPORTING_DATA, payload: res, loading: false });
          return { success: true, ...res }; 
      } else {
          dispatch({ type: GET_REPORTING_END, payload: res.message, loading: false });
          return { success: false, ...res }; 
      }
  } catch (error: any) {
      dispatch({ type: GET_REPORTING_END, payload: error.message, loading: false });
      return { success: false, message: error.message };
  }
};


// export const ReportList = (): any => async (dispatch: Dispatch): Promise<any> => {
//   try {
//     dispatch({ type: GET_REPORTING_START, loading: true });

//     const token = localStorage.getItem("loginToken");
//     if (!token) {
//       throw new Error("Authorization token not found");
//     }

//     const response = await fetch(`${API_URL}/filter-fields/getAll`, {
//       method: "GET",
//       headers: {
//         'Content-Type': 'application/json',
//         'Authorization': `Bearer ${token}`,
//       },
//     });

//     const res = await response.json();

//     if (response.ok) {
//       dispatch({ type: GET_REPORTING_DATA, payload: res, loading: false });
//       return { success: true, ...res };
//     } else {
//       dispatch({ type: GET_REPORTING_END, payload: res.message, loading: false });
//       return { success: false, ...res };
//     }
//   } catch (error: any) {
//     dispatch({ type: GET_REPORTING_END, payload: error.message, loading: false });
//     return { success: false, message: error.message };
//   }
// };


